import { connect } from 'react-redux';
import ShortCodeLogin from './ShortCodeLogin';
import {
  isAuthenticating,
  getError,
  isAuthenticated,
} from '../../../state/reducers/LoginReducer';
import LoginActions from '../../../state/actions/LoginActions';

let { loginRequest } = LoginActions;

export default connect(
  (state) => ({
    authenticating: isAuthenticating(state),
    error: getError(state),
    isAuthenticated: isAuthenticated(state),
  }),
  {
    login: loginRequest,
  }
)(ShortCodeLogin);



// WEBPACK FOOTER //
// ./src/view/scenes/ShortCodeLogin/index.js